document.addEventListener('DOMContentLoaded', function () {
    const customSelects = document.querySelectorAll('.custom-select');
    if (!customSelects.length) return;

    customSelects.forEach(select => {
        const trigger = select.querySelector('.select-trigger');
        const options = select.querySelector('.select-options');
        const valueElement = select.querySelector('.select-value');
        const hiddenInput = select.closest('.input-group')?.querySelector('input[type="hidden"]');


        if (!trigger || !options || !valueElement) return;

        trigger.addEventListener('click', () => {
            trigger.classList.toggle('active');
            options.classList.toggle('show');
        });

        options.addEventListener('click', (e) => {
            if (e.target && e.target.classList.contains('option')) {
                const value = e.target.dataset.value;
                const text = e.target.textContent;

                if (valueElement) valueElement.textContent = text;
                if (hiddenInput) hiddenInput.value = value;


                const allOptions = options.querySelectorAll('.option');
                if (allOptions.length) {
                    allOptions.forEach(opt => opt.classList.remove('selected'));
                }


                e.target.classList.add('selected');

                trigger.classList.remove('active');
                options.classList.remove('show');
            }
        });


        document.addEventListener('click', (e) => {
            if (select && !select.contains(e.target)) {
                if (trigger) trigger.classList.remove('active');
                if (options) options.classList.remove('show');
            }
        });
    });
});